import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4422c1c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-filters-analysis text-white bg-primary-dark p-10 rounded" }
const _hoisted_2 = { class: "c-filters-analysis__header flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Perguntas", -1))
const _hoisted_4 = { class: "c-filters-analysis__content mt-5 xl:flex" }
const _hoisted_5 = { class: "w-full mb-3 xl:mr-10" }
const _hoisted_6 = {
  for: "tNuncaEleitos",
  class: "flex items-center cursor-pointer"
}
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-3 bg-gray-400 rounded-full shadow-inner" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot absolute w-5 h-5 bg-white rounded-full shadow -left-1 -top-1 transition" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-white font-medium text-base" }, " Quantas nunca foram eleitas? ", -1))
const _hoisted_11 = { class: "w-full mb-3 xl:mr-10" }
const _hoisted_12 = {
  for: "tElectionsWon",
  class: "flex items-center cursor-pointer"
}
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-3 bg-gray-400 rounded-full shadow-inner" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot absolute w-5 h-5 bg-white rounded-full shadow -left-1 -top-1 transition" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-white font-medium text-base" }, " Quantas já foram eleitas? ", -1))
const _hoisted_17 = { class: "w-full mb-3 xl:mr-10" }
const _hoisted_18 = {
  for: "tNElections",
  class: "flex items-center cursor-pointer"
}
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-3 bg-gray-400 rounded-full shadow-inner" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot absolute w-5 h-5 bg-white rounded-full shadow -left-1 -top-1 transition" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-white font-medium text-base" }, " Quantas nunca concorreram? ", -1))
const _hoisted_23 = { class: "w-full mb-3 mr-10" }
const _hoisted_24 = {
  for: "tMulheres",
  class: "flex items-center cursor-pointer"
}
const _hoisted_25 = { class: "relative" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-3 bg-gray-400 rounded-full shadow-inner" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot absolute w-5 h-5 bg-white rounded-full shadow -left-1 -top-1 transition" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-white font-medium text-base" }, " Quantas são mulheres? ", -1))
const _hoisted_29 = { class: "w-full mb-3" }
const _hoisted_30 = {
  for: "tHomens",
  class: "flex items-center cursor-pointer"
}
const _hoisted_31 = { class: "relative" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-3 bg-gray-400 rounded-full shadow-inner" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot absolute w-5 h-5 bg-white rounded-full shadow -left-1 -top-1 transition" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-white font-medium text-base" }, " Quantos são homens? ", -1))
const _hoisted_35 = { class: "w-full mb-3" }
const _hoisted_36 = {
  for: "tPPI",
  class: "flex items-center cursor-pointer"
}
const _hoisted_37 = { class: "relative" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-3 bg-gray-400 rounded-full shadow-inner" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot absolute w-5 h-5 bg-white rounded-full shadow -left-1 -top-1 transition" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-white font-medium text-base" }, " Quantas são PPI (pretas, pardas e indígenas)? ", -1))
const _hoisted_41 = { class: "w-full mb-3" }
const _hoisted_42 = {
  for: "tBrancos",
  class: "flex items-center cursor-pointer"
}
const _hoisted_43 = { class: "relative" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-3 bg-gray-400 rounded-full shadow-inner" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot absolute w-5 h-5 bg-white rounded-full shadow -left-1 -top-1 transition" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-white font-medium text-base" }, " Quantas são brancas? ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearAnalysis())),
        class: "text-secondary-base ml-5 text-sm underline hover:no-underline"
      }, " Limpar filtros ")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                id: "tNuncaEleitos",
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkedElections) = $event)),
                class: "sr-only"
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkedElections]
              ]),
              _hoisted_8,
              _hoisted_9
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                id: "tElectionsWon",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedElectionsWon) = $event)),
                type: "checkbox",
                class: "sr-only"
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkedElectionsWon]
              ]),
              _hoisted_14,
              _hoisted_15
            ]),
            _hoisted_16
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                id: "tNElections",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkedNElections) = $event)),
                type: "checkbox",
                class: "sr-only"
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkedNElections]
              ]),
              _hoisted_20,
              _hoisted_21
            ]),
            _hoisted_22
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                id: "tMulheres",
                value: "tMulheres",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkedWoman) = $event)),
                type: "checkbox",
                class: "sr-only"
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkedWoman]
              ]),
              _hoisted_26,
              _hoisted_27
            ]),
            _hoisted_28
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("label", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                id: "tHomens",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkedMan) = $event)),
                type: "checkbox",
                class: "sr-only"
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkedMan]
              ]),
              _hoisted_32,
              _hoisted_33
            ]),
            _hoisted_34
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("label", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                id: "tPPI",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkedPPI) = $event)),
                type: "checkbox",
                class: "sr-only"
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkedPPI]
              ]),
              _hoisted_38,
              _hoisted_39
            ]),
            _hoisted_40
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("label", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _withDirectives(_createElementVNode("input", {
                id: "tBrancos",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkedWhite) = $event)),
                type: "checkbox",
                class: "sr-only"
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkedWhite]
              ]),
              _hoisted_44,
              _hoisted_45
            ]),
            _hoisted_46
          ])
        ])
      ])
    ])
  ]))
}